<template>
	<TheNotice></TheNotice>
	<TheHeader></TheHeader>
	
	<div class="container-fluid">
		<div class="container">
			<form name="form">
				<div class="contain row">
					<TheSidebar></TheSidebar>
					
					<div class="page-container card col-md-8">
						<ThePageHeader></ThePageHeader>
						
						<div class="row">
							<div class="row col-md-12 p-4">
								<div class="col-md-6" v-for="notification in notifications" :key="notification.items">
									<Card>
										<template #title>{{notification.title}}</template>
										
										<template #content>
											<div v-if="notification.isLoading">
												<div v-for="item in notification.items" :key="item">
													<Skeleton width="50%" height="1.5rem" class="mb-2"></Skeleton>
													<Skeleton height="2rem" class="mb-2"></Skeleton>
												</div>
											</div>
											
											<div v-if="!notification.isLoading">
												<div v-for="item in notification.items" :key="item.count">
													<div class="p-card-subtitle p-card-subtitile-notification" :class="item.class">{{item.subtitle}} 
																<Badge class="ml-2" :class="'p-badge-success'" :value="'Active'" v-if="notification.title == 'Publications' && !item.isClosed"/>
															</div>
													
													<div v-if="notification.title == 'Follow-Ups'">
														<p>There are <Button class="p-button-link ps-0 pe-0 pt-0 pb-0" :label="item.count.toString()" @click="viewNotification(item.url, item.status)"/> {{item.subtitle}}<span v-if="item.type == 'RPK'"> from {{item.companyCount}} company(ies)</span>.</p>
													</div>
													
													<div class="row col-md-12" v-if="notification.title == 'Publications'">
														<i class="pi pi-pencil col-md-1 text-primary" style="font-size: 1rem;" />
														<div class="row col-md-11">
															<p>{{formatToDayMonthYear(item.lastModifiedDate)}} {{formatToDateTime(item.lastModifiedDate).substring(10) }}</p>
														</div>
													</div>
												</div>
											</div>
										</template>
									</Card>
								</div>
							</div>
						</div>
					</div>
					
					<TheFooter></TheFooter>
				</div>
			</form>
		</div>
	</div>
	
	<Dialog :header="'Reset Password'" v-model:visible="isResetPassword" :style="{width: '50vw'}" :draggable="false" :closable="false" :modal="true" :dismissableMask="false">
		<div>
			<div class="mb-4">
				<p>To make your account secure, you are required to change your password immediately to replace the temporary password you were given.</p>
			</div>

			<div class="col-md-12 d-flex">
				<div class="col-md-8 pe-2">
					<div class="row mb-3">
						<div class="col-md-5 required">
							<label class="col-form-label-title">New Password:</label>
						</div>
						
						<div class="col-md-7">
							<Password :strongRegex="strongRegex" :class="{'p-invalid': (passwordNotMatch || v$.password.$invalid) && password != ''}" toggleMask v-model="password"></Password>
						</div>
					</div>
					
					<div class="row mb-0">
						<div class="col-md-5 required">
							<label class="col-form-label-title">Confirm Password:</label>
						</div>
						
						<div class="col-md-7">
							<Password :strongRegex="strongRegex" v-model="confirmPassword" :inputClass="{'p-invalid': (passwordNotMatch || v$.confirmPassword.$invalid)  && confirmPassword != ''}" toggleMask></Password>
						</div>
						
						<div class="col-md-5" v-if="passwordNotMatch"></div>
													
						<small class="col-md-7 p-error" v-if="passwordNotMatch">Passwords do not matched.</small>
					</div>
				</div>

				<div class="col-md-4 ps-2">
					<div class="col-md-12">
						<div class="row">
							<div class="col-md-12">
								<label class="col-form-password-policy-title">Password Policy:</label>
								<ul class="pl-2 ml-2 mt-0 col-form-password-policy">
									<li v-for="policies in passwordPolicy" :key="policies">{{ policies }}</li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		
		<template #footer>
			<div class="d-flex justify-content-end">
				<TheLoading v-if="isResetPasswordLoading"></TheLoading>
				
				<Button class="p-button-text p-button-sm" label="Logout" icon="pi pi-sign-out" @click="logout" />
				<Button class="p-button-sm me-0" label="Confirm" icon="pi pi-check" @click="resetPassword" :disabled="v$.password.$invalid || v$.confirmPassword.$invalid" />
			</div>
		</template>
	</Dialog>
</template>

<script lang="ts">
	import { defineComponent } from "vue";
	import { useRoute } from "vue-router";
	import store from "@/store";
	import companyReportApi from "@/api/companyreport-api";
	import templateApi from "@/api/template-api";
	import userApi from "@/api/user-api";
	import dateUtilsMixin from "@/mixin/utils/date-utils";
	import passwordUtilsMixin, { strongRegexValidator } from "@/mixin/utils/password-utils";
	
	import { Md5 } from "ts-md5";
	
	import TheHeader from "@/components/TheHeader.vue";
	import TheFooter from "@/components/TheFooter.vue";
	import TheSidebar from "@/components/TheSidebar.vue";
	import ThePageHeader from "@/components/ThePageHeader.vue";
	import TheLoading from "@/components/TheLoading.vue";
	import TheNotice from "@/components/TheNotice.vue";
	
	import useVuelidate from "@vuelidate/core";
	import { required } from "@vuelidate/validators";
	
	export default defineComponent({
		mixins: [dateUtilsMixin, passwordUtilsMixin],
        components: {
			TheHeader,
			TheFooter,
			TheSidebar,
			ThePageHeader,
			TheLoading,
			TheNotice,
		},
		data() {
			return {
				notifications: [
					{'isLoading': true, 'error': '', 'title': 'Follow-Ups', items:[{}, {}]}, 
					{'isLoading': true, 'error': '', 'title': 'Publications', items:[{}, {}, {}]}
				],
				isLoading: false,
				isResetPassword: false,
				passwordNotMatch: false,
				isResetPasswordLoading: false,
				password: '',
				confirmPassword: '',
				employee: store.getters.getSession.employee,
			}
		},
		watch: {
			filterLegalGroup(newValue: any) {				
				this.load();
			}
		},
		computed: {
			filterLegalGroup() {
				return (store.getters.getFilterLegalGroupModel != null ? store.getters.getFilterLegalGroupModel : null);
			}
		},
		mounted: function() {
			if (this.$store.getters.getSession.isForceUpdatePassword) {
				this.isResetPassword = true;
			}
			
			else {
				this.isResetPassword = false;
				this.load();
			}
		},
		methods: {
			load() {
				this.notifications.forEach((notification: any, index: any) => {
					notification.isLoading = true;
					if (index == 0) {
						companyReportApi.companyReportNotification({value: this.filterLegalGroup})
							.then(response => {
								notification.items = response.data.listSet;
								notification.isLoading = false;
								
							})
							.catch(error => {
								notification.error = error;
								notification.isLoading = false;
							})
					}
					
					else if (index == 1) {
						templateApi.templateNotification()
							.then(response => {
								notification.items = response.data.listSet;
								notification.isLoading = false;
							})
							.catch(error => {
								notification.error = error;
								notification.isLoading = false;
							})
					}
				});
			},
			toLowerCase(value: any) {
				if (value != null) {
					return value.toLowerCase();
				}
			},
			viewNotification(url: any, status: any){
				let route = this.$router.resolve({path: url, query: (url == '/submission' ? {}: {status: status})});
				if (url == '/submission') {
					window.open(route.href, "_blank");
				}
				
				else {
					window.open(route.href, "_self");				
				}
			},
			resetPassword() {
				this.passwordNotMatch = false;
				if(this.password == this.confirmPassword) {
					
					this.isResetPasswordLoading = true;
					userApi.userUpdatePasswordForce({
							username: this.employee.emailAddress,
							newPassword: Md5.hashStr(this.password)
						})
						.then((response: any) => {
							this.isResetPasswordLoading = false;
							
							this.$store.dispatch('updateIsForceUpdatePassword', response)
								.then((response) => {
									this.isResetPassword = false;
									this.$toast.add({severity: "success", summary: "Success", detail: response.message, life: 6000});
									this.load();
								})
						})
						.catch(error => {
							this.isResetPasswordLoading = false;
							this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
						})
				}
				
				else {
					this.passwordNotMatch = true;
				}
			},
			logout() {
				this.$store.dispatch("logout")
					.then(() => {
						this.$router.push("/login");
					})
					.catch(() => {
						this.$router.push("/login");
					})
			}
		},
		setup() {
			return {v$: useVuelidate()}
		},
		validations() {
			return {
				password: {
					required, strongRegexValidator
				},
				confirmPassword: {
					required, strongRegexValidator
				}
			}
		}
	});
</script>
